import { connect } from 'react-redux';
import { clearActivityGroupSelection } from '../../redux/reducers/selectedActivityGroups';
import ClearButton from './ClearButton';

const actionCreators = {
  clearActivityGroupSelection
};

export default connect(null, actionCreators)(ClearButton);



// WEBPACK FOOTER //
// ./src/components/ActivityGroupFilter/ClearButtonContainer.js